<template>
  <div class="wrapper">
    <nav-bar />
    <side-bar />
    <router-view/>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Layouts/Footer";
import SideBar from "@/components/Layouts/SideBar";
import NavBar from "@/components/Layouts/NavBar";
import {getUserData, isUserLoggedIn} from "@/helpers/Utils";

export default {
  name: "Main",
  components: {
    Footer,
    SideBar,
    NavBar,
  },
  created() {
    document.body.className = 'hold-transition sidebar-mini layout-fixed';
    if (isUserLoggedIn()) {
      this.$store.dispatch('user/USER_LOGGED_IN', getUserData());
    }
  }
}
</script>

<style scoped>

</style>
